import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Recruitments", -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "row g-6 mb-6 align-items-end" }
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = { class: "seq-period-filter mb-0" }
const _hoisted_9 = { class: "seq-period-filter__field seq-period-filter__field--date" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "From Date", -1)
const _hoisted_11 = { class: "seq-period-filter__field seq-period-filter__field--date" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "To Date", -1)
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = { class: "ag-theme-alpine seq-ag-grid seq-ag-grid--recruitments" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_StatCard = _resolveComponent("StatCard")
  const _component_ag_grid_vue = _resolveComponent("ag-grid-vue")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading_init]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Group.svg" })
          ]),
          _hoisted_4
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "seq-period-filter__input",
                  name: "from_date",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.from_date = $event))
                }, null, 512), [
                  [_vModelText, _ctx.from_date]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "seq-period-filter__input",
                  name: "to_date",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.to_date = $event))
                }, null, 512), [
                  [_vModelText, _ctx.to_date]
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn btn-seq-view",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.recruitmentshistory()))
              }, " View ")
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_StatCard, {
              label: "Search Results",
              icon: "media/icons/duotone/Communication/Group.svg",
              value: _ctx.recruitment_length,
              "currency-symbol": "",
              period: "",
              decimals: 0
            }, null, 8, ["value"])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_ag_grid_vue, {
            class: "seq-ag-grid__canvas",
            columnDefs: _ctx.columnDefs,
            defaultColDef: _ctx.defaultColDef,
            rowHeight: 68,
            headerHeight: 44,
            rowModelType: "infinite",
            pagination: true,
            paginationPageSize: _ctx.itemsPerPage,
            cacheBlockSize: 100,
            onGridReady: _ctx.onGridReady
          }, null, 8, ["columnDefs", "defaultColDef", "paginationPageSize", "onGridReady"])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading_init]
    ])
  ], 64))
}